import { useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useReduxState } from 'hooks';
import { SearchForm } from 'components/common';

interface Props {
  initialValue: string | undefined;
}

const CoursesSearch = ({ initialValue }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const router = useRouter();

  const [previousView, setPreviousView] = useState<string>();

  const handleClear = async () => {
    router.push(`/courses?type=${previousView || 'all'}`, undefined, {
      shallow: true
    });
  };

  const handleError = async (err: Error) => dispatch.handleErrorDispatch(err);

  const handleSearch = async (value: string) => {
    if (router.query.type !== 'search') {
      setPreviousView(router.query.type as string);
    }

    router.push(`/courses?type=search&search=${value}`, undefined, {
      shallow: true
    });
  };

  return (
    <SearchForm
      initialValue={initialValue}
      placeholderText={messages.coursesSearch}
      onClear={handleClear}
      onError={handleError}
      onSearch={handleSearch}
    />
  );
};

export default CoursesSearch;
